import _defineProperty from "@babel/runtime/helpers/defineProperty";
const connectError = '@duplexer:connect_error';
const subscriptionFailed = '@duplexer:subscription_failed';
const SOCKET_RECONNECT_TIMEOUT = 5000;
export class DuplexerSubscriber {
  constructor(duplexer, appDefId, logger) {
    this.duplexer = duplexer;
    this.appDefId = appDefId;
    this.logger = logger;
    _defineProperty(this, "socket", void 0);
    _defineProperty(this, "channel", void 0);
    _defineProperty(this, "socketTimer", void 0);
    _defineProperty(this, "channelTimer", void 0);
    _defineProperty(this, "activeSubscriptions", []);
    this.connectSocket();
  }
  connectSocket() {
    this.socket = this.duplexer.connect({
      appDefId: this.appDefId
    });
    this.socket.on(connectError, error => {
      this.logError(connectError, error);
      this.socket.disconnect();
      this.clearTimeoutSafe(this.socketTimer);
      this.socketTimer = setTimeout(() => this.connectSocket(), SOCKET_RECONNECT_TIMEOUT);
    });
    this.connectChannel();
  }
  connectChannel() {
    this.channel = this.socket.subscribeToUserChannel();
    this.channel.on(subscriptionFailed, error => {
      this.logError(subscriptionFailed, error);
      this.channel.unsubscribe();
      this.socket.disconnect();
      this.clearTimeoutSafe(this.channelTimer);
      this.channelTimer = setTimeout(() => {
        this.connectSocket();
        // Resubscribing to the existing subscriptions
        this.activeSubscriptions.forEach(_ref => {
          let {
            event,
            handler
          } = _ref;
          this.channel.on(event, handler);
        });
      }, SOCKET_RECONNECT_TIMEOUT);
    });
  }
  subscribe(event, handler) {
    this.channel.on(event, handler);
    this.activeSubscriptions.push({
      event,
      handler
    });
  }
  once(event, handler) {
    this.channel.once(event, handler);
  }
  unsubscribe() {
    this.clearTimeoutSafe(this.socketTimer);
    this.clearTimeoutSafe(this.channelTimer);
    this.socket.removeAllListeners();
    this.channel.removeAllListeners();
    this.activeSubscriptions = [];
  }
  clearTimeoutSafe(timer) {
    if (timer) {
      clearTimeout(timer);
    }
  }
  logError(message, error) {
    this.logger.log({
      message,
      error,
      callParams: {
        appDefId: this.appDefId
      }
    });
  }
}
//# sourceMappingURL=DuplexerSubscriber.js.map